import { render, staticRenderFns } from "./TabLifeCycle.vue?vue&type=template&id=6aa638b7&scoped=true&"
import script from "./TabLifeCycle.vue?vue&type=script&lang=js&"
export * from "./TabLifeCycle.vue?vue&type=script&lang=js&"
import style0 from "./TabLifeCycle.vue?vue&type=style&index=0&id=6aa638b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa638b7",
  null
  
)

export default component.exports